import { Card } from "../../models/card";
import { GreenGem } from "../resources/greenGem";
import { cards } from "../../state";
import { forceUpdate, dropCard } from "../..";
export class GreenGemMaker extends Card {
}
GreenGemMaker.displayName = "Green Gem";
GreenGemMaker.artUrl = "./assets/cards/greengem.jpg";
GreenGemMaker.effect = {
    callback: (card) => {
        let newPos = { x: card.position.x - 8, y: card.position.y - 180 };
        const newCard = new GreenGem(newPos);
        cards.push(newCard);
        forceUpdate();
        dropCard(newCard);
    },
    description: "Get a Green Gem",
    needsFeedback: false,
};
